
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Bushireforpicnicinpune() {



    const cardData =
    {
        keyword: 'Bus Hire for Picnic in Pune',
        heading: 'Amruta Travels: Bus Hire for Picnic in Pune',
        headingDescription: 'Amruta Travels offers Bus Hire for Picnic in Pune, providing comfortable and reliable transportation solutions for your group outings. Whether you are organizing a school picnic, corporate retreat, or a family day out, our well-maintained buses ensure a smooth and enjoyable journey to your chosen picnic spot. Choose from our fleet of 17-seater, 32-seater, and 50-seater buses, all driven by experienced and courteous drivers. With punctual service, affordable pricing, and 24/7 availability, Amruta Travels makes your picnic travel in and around Pune simple and stress-free. Book your picnic bus with Amruta Travels and embark on a journey of comfort and fun!',


        top: 'Top Places to Visit in Pune with Amruta Travels',
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



"services": [
    {
      "name": "Bus Rental Services in Pune",
      "description": "Amruta Travels offers reliable bus rental services in Pune for various travel needs. Whether it’s for group trips, corporate outings, school picnics, or special events, we provide well-maintained buses with experienced drivers to ensure a safe and comfortable journey."
    },
    {
      "name": "Pune to Mahabaleshwar Bus for Picnic",
      "description": "Plan your picnic to Mahabaleshwar with Amruta Travels. We provide comfortable buses for groups of all sizes, ensuring a pleasant and scenic journey to this popular hill station. Enjoy the lush greenery and cool climate of Mahabaleshwar with our well-maintained vehicles."
    },
    {
      "name": "Pune Darshan Bus Hire for Picnic",
      "description": "Explore the best of Pune with our Darshan bus hire for picnics. Whether it’s a cultural tour or sightseeing tour, we offer comfortable and reliable buses with expert drivers to make your Pune Darshan experience memorable."
    },
    {
      "name": "Pune to Mysore Ooty Bus Hire for Picnic",
      "description": "Take your picnic to the scenic hill stations of Mysore and Ooty with Amruta Travels. We offer buses for group travel to these beautiful destinations, ensuring comfort, safety, and timely travel with AC or non-AC options available."
    },
    {
      "name": "Bus Rental for Corporate Outing in Pune",
      "description": "Amruta Travels offers bus rental services for corporate outings in Pune. Whether it's for team-building, conferences, or any corporate event, our buses are perfect for large groups, with a focus on comfort, punctuality, and professional service."
    },
    {
      "name": "Bus Hire for School Picnic in Pimpri Chinchwad",
      "description": "Planning a school picnic in Pimpri Chinchwad? Amruta Travels provides safe and comfortable bus rentals for school trips. We ensure timely service and a hassle-free experience, with buses equipped with safety features and friendly drivers."
    },
    {
      "name": "Bus Hire for School Picnic in Pune",
      "description": "Amruta Travels offers reliable bus hire services for school picnics in Pune. We provide buses of various sizes to accommodate large groups of students, ensuring a fun, safe, and educational trip to nearby attractions."
    },
    {
      "name": "Bus Hire for Outstation Picnic in Pune",
      "description": "Take your picnic to nearby outstation destinations with Amruta Travels. We offer comfortable buses for long-distance trips, perfect for group outings, family picnics, and corporate events. Enjoy a scenic ride with professional drivers ensuring a smooth experience."
    },
    {
      "name": "Party Minibus Hire Near Me",
      "description": "Celebrate your party in style with a minibus hire from Amruta Travels. Whether it’s a birthday, anniversary, or any special event, our party minibuses are equipped with entertainment features, comfortable seating, and ample space for a memorable journey."
    },
    {
      "name": "Pune to Shirdi Bus Hire",
      "description": "Travel to the spiritual city of Shirdi with Amruta Travels’ bus rental services. We offer comfortable buses for religious trips, ensuring timely arrivals and safe travel for groups visiting the famous Sai Baba Temple."
    },
    {
      "name": "Pune to Aurangabad Bus on Rent",
      "description": "Amruta Travels offers bus rental services from Pune to Aurangabad, perfect for pilgrims and tourists visiting famous landmarks like the Ajanta and Ellora caves. Our buses ensure a comfortable and smooth journey with professional drivers and timely service."
    }
  ],
  "tableData": [
    ["Bus Rental Services in Pune", "Pune to Mahabaleshwar Bus for Picnic"],
    ["Pune Darshan Bus Hire for Picnic", "Pune to Mysore Ooty Bus Hire for Picnic"],
    ["Bus Rental for Corporate Outing in Pune", "Bus Hire for School Picnic in Pimpri Chinchwad"],
    ["Bus Hire for School Picnic in Pune", "Bus Hire for Outstation Picnic in Pune"],
    ["Party Minibus Hire Near Me", "Pune to Shirdi Bus Hire"],
    ["Pune to Aurangabad Bus on Rent", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Perfect Bus Hire for Picnics in Pune",
    "WhyChoosedescription": "Amruta Travels offers Bus Hire for Picnic in Pune, designed to make your group outings fun and comfortable. Whether you're heading to a nearby hill station, lake, or nature park, our well-maintained buses ensure your group enjoys a smooth, relaxed journey with ample space for luggage, food, and picnic essentials."
  },
  {
    "WhyChooseheading": "Spacious Buses for Large Groups",
    "WhyChoosedescription": "We provide buses of various sizes including 17, 20, 32, 35, 40, 45, and 50-seaters to suit your picnic group size. With spacious seating arrangements, air conditioning, and enough room for coolers, bags, and picnic gear, your group will enjoy a comfortable and pleasant ride to your picnic destination."
  },
  {
    "WhyChooseheading": "Ideal for Day Trips, Nature Visits, and Outdoor Adventures",
    "WhyChoosedescription": "Our Bus Hire for Picnic service is perfect for day trips to locations like Lonavala, Khandala, Sinhagad Fort, Pavana Lake, and more. Whether you're visiting a scenic spot or embarking on an outdoor adventure, we ensure your group arrives relaxed and ready for a great time."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Safe and Scenic Routes",
    "WhyChoosedescription": "Our professional drivers are skilled at navigating Pune's roads and scenic routes to popular picnic spots. Whether you're traveling through hilly terrains or city roads, they ensure a safe, smooth, and enjoyable journey. They also know the best stops for refreshments along the way, making your picnic experience even more pleasant."
  },
  {
    "WhyChooseheading": "Affordable Pricing with No Hidden Fees",
    "WhyChoosedescription": "Amruta Travels offers affordable rates for Bus Hire for Picnic in Pune, with transparent pricing and no hidden charges. Our pricing is designed to provide the best value for group travel, so you can focus on enjoying your picnic rather than worrying about costs."
  },
  {
    "WhyChooseheading": "Clean, Well-Maintained Buses for Comfort and Hygiene",
    "WhyChoosedescription": "All our buses are regularly cleaned and well-maintained to ensure hygiene and comfort for your group. With clean interiors, push-back seating, large windows, and air conditioning, we provide a smooth and refreshing ride—perfect for a day out in nature."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop-off Locations Across Pune",
    "WhyChoosedescription": "We offer flexible pickup and drop-off options from anywhere in Pune—be it your home, office, or a designated meeting point. Whether you're traveling from Aundh, Baner, Kothrud, or Hadapsar, we ensure punctual pickups and convenient drop-offs after your picnic."
  },
  {
    "WhyChooseheading": "Easy Booking and Friendly Customer Support",
    "WhyChoosedescription": "Booking a bus for your picnic is quick and easy with Amruta Travels. You can book online, over the phone, or by visiting our office. Our customer support team is available to assist you with any inquiries, help you choose the right vehicle, and ensure everything goes smoothly on the day of your picnic."
  }
]























    }

const faqData = [
  {
    question: 'How can I hire a bus for a picnic in Pune?',
    answer: 'Hiring a bus for a picnic in Pune is easy with Amruta Travels. You can book a bus by calling us, visiting our office, or booking online. We’ll help you choose the best bus based on your group size and destination.',
  },
  {
    question: 'What types of buses are available for picnic hire in Pune?',
    answer: 'We provide a range of buses for picnic hire, including 32, 35, 40, 45, and 50-seater options. Our fleet includes AC, non-AC, and luxury buses, ensuring a comfortable and enjoyable journey to your picnic spot.',
  },
  {
    question: 'Can I rent a bus for a picnic to nearby places from Pune?',
    answer: 'Yes, we offer buses for picnic trips to nearby destinations such as Lonavala, Mahabaleshwar, Matheran, and other scenic spots near Pune. We ensure your group travels comfortably and safely.',
  },
  {
    question: 'Is food allowed on the bus during a picnic trip?',
    answer: 'Yes, food and beverages are allowed on our buses during picnic trips. We recommend that you keep the bus clean, and our team will make sure to sanitize and prepare the bus before and after the trip.',
  },
  {
    question: 'How much does it cost to hire a bus for a picnic in Pune?',
    answer: 'The cost of hiring a bus for a picnic depends on factors like the bus type, trip distance, duration, and any special requirements. Contact us for a personalized quote based on your picnic plan.',
  },
  {
    question: 'Are the buses safe for picnic trips?',
    answer: 'Yes, all our buses are well-maintained and equipped with safety features. Our drivers are experienced, licensed, and committed to ensuring a safe and enjoyable picnic trip.',
  },
  {
    question: 'Do you provide buses with a driver for picnic trips?',
    answer: 'Yes, all our buses come with professional and courteous drivers who are familiar with the best picnic destinations. They will ensure a smooth and safe journey.',
  },
  {
    question: 'Can I request multiple pickup points for a picnic trip in Pune?',
    answer: 'Yes, we offer flexible pickup and drop-off points. Just let us know your group’s itinerary, and we’ll plan the best route to suit your picnic trip.',
  },
  {
    question: 'Why choose Amruta Travels for bus hire for a picnic in Pune?',
    answer: 'Amruta Travels is known for its reliable service, well-maintained buses, and professional drivers. We make sure that your picnic trip is comfortable, stress-free, and memorable.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Sanjay Kulkarni',
    role: 'Group Leader, Picnic Group',
    text: 'We rented a 40-seater bus from Amruta Travels for a picnic to Lonavala. The bus was clean, the driver was very helpful, and the trip was smooth. Everyone had a great time. I highly recommend their service!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Anita Patil',
    role: 'Event Organizer, Pune',
    text: 'Amruta Travels provided a 35-seater luxury bus for our picnic to Mahabaleshwar. The experience was fantastic, with comfortable seating and excellent service. We will definitely book with them again.',
    rating: 5,
  },
];



























































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire for Picnic in Pune",
  "image": "https://bushireinpune.com/assets/images/bus-hire-for-picnic-in-pune.jpg",
  "description": "Affordable bus hire for picnics in Pune including destinations like Mahabaleshwar, Mysore, Ooty, Shirdi, and Aurangabad. Perfect for school trips, corporate outings, and Pune Darshan. Choose from mini and party buses, 17 to 50 seaters with AC/Non-AC options. Safe, punctual, and comfortable travel with Amruta Travels.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7020"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3799",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/bus-hire-for-picnic-in-pune"
  }
};





    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Bus Hire for Picnic in Pune | School, Corporate & Group Outings</title>
  <meta 
    name="description" 
    content="Book bus hire in Pune for picnics to Mahabaleshwar, Ooty, Shirdi & more. 17 to 50 seater AC/Non-AC buses for school trips, corporate outings & family tours. Amruta Travels - Safe & reliable." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/47.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bushireforpicnicinpune;